import { render, staticRenderFns } from "./p-checked-texfield.vue?vue&type=template&id=2a446ea1&"
import script from "./p-checked-texfield.vue?vue&type=script&lang=js&"
export * from "./p-checked-texfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports